// tools function
export default {

  // has file icon
  fileicon(ext){
      if (!ext) return false
      ext = ext.toLowerCase()
      switch (ext) {
        case 'ai':
        case 'avi':
        case 'bmp':
        case 'crd':
        case 'csv':
        case 'dll':
        case 'doc':
        case 'docx':
        case 'dwg':
        case 'eps':
        case 'exe':
        case 'flv':
        case 'giff':
        case 'html':
        case 'iso':
        case 'java':
        case 'jpg':
        case 'mdb':
        case 'mid':
        case 'mov':
        case 'mp3':
        case 'mp4':
        case 'mpeg':
        case 'pdf':
        case 'png':
        case 'ppt':
        case 'ps':
        case 'psd':
        case 'pub':
        case 'rar':
        case 'raw':
        case 'rss':
        case 'svg':
        case 'tiff':
        case 'txt':
        case 'wav':
        case 'wma':
        case 'xml':
        case 'xsl':
        case 'zip':
          return true      
        default:
          return false
      }
    }


}